export const PAGE_TYPE = {
  PAGE: "app_page",
  PRIVACY_CENTER: "app_privacy_center",
}


export const PAGE_TYPEHANDLE = {
  PRIVACY_CENTER: "clubdataprivacycenterpage",
}